import React from 'react';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { TropicalLeaf } from './botanical/TropicalLeaf';
import { Eucalyptus } from './botanical/Eucalyptus';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png';
export function NewHero() {
  return <section className="min-h-[100svh] flex flex-col justify-center bg-cream-warm relative overflow-hidden px-4 py-6" data-id="element-143">
      <TropicalLeaf className="absolute -top-20 -left-20 w-72 h-72 text-moss opacity-10 blur-sm rotate-45 pointer-events-none" aria-hidden="true" data-id="element-144" />
      <Eucalyptus className="absolute bottom-10 -right-10 w-56 h-56 text-sage-deep opacity-15 blur-[2px] -rotate-12 pointer-events-none" aria-hidden="true" data-id="element-145" />

      <div className="max-w-xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-146">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-forest-deep leading-tight mb-3 text-balance" data-id="element-147">
          Aprendé qué hacer cuando algo duele en casa.
        </h1>

        <p className="text-base sm:text-lg text-forest/80 mb-5 leading-relaxed text-balance font-medium max-w-lg" data-id="element-148">
          Nunca más te quedes sin saber qué hacer cuando alguien en tu casa se
          siente mal. Respuestas claras en minutos, sin perder horas buscando en
          Google.
        </p>

        {/* Mockup del producto entre subtítulo y CTA */}
        <div className="relative mx-auto mb-6 w-full max-w-[230px] sm:max-w-[260px]" data-id="element-149">
          <div aria-hidden="true" className="absolute inset-0 bg-honey/20 blur-3xl rounded-full scale-90" data-id="element-150" />
          <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-honey/20 shadow-[0_24px_48px_-12px_rgba(0,0,0,0.4),0_0_40px_-10px_rgba(212,162,76,0.3)] bg-forest-mist" data-id="element-151">
            <img src={PRODUCT_IMAGE} alt="Hogar Natural en Casa — guías naturales en formato digital" className="w-full h-full object-cover" data-id="element-152" />
          </div>
        </div>

        <Button variant="primary" size="lg" href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white shadow-lg text-base sm:text-lg tracking-wide w-full sm:w-auto px-8 py-4 flex-col gap-0.5" data-id="element-153">
          <span data-id="element-154">👉 QUIERO SABER QUÉ HACER EN CASA</span>
          <span className="text-sm font-semibold text-honey-light" data-id="element-155">
            Acceso inmediato — $19.999
          </span>
        </Button>
      </div>
    </section>;
}